import React, { useEffect, useMemo, useState } from 'react'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete'
import clsx from 'clsx'
import { Helmet } from 'react-helmet'
import { deleteExtraMedicineForSupply } from '../../../Backend/firebase/supply-order'
import { FixedSizeList as List } from "react-window"; // Virtual scrolling
import { debounce } from 'lodash';
import { loadAllMedicine } from '../../../mock/common';

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function SupplyMedicine() {
  const classes = useStyles();
  const history = useHistory()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [searchQuery, setSearchQuery] = useState("");
  const [recordFromExcelSheet, setRecordFromExcelSheet] = useState([]);
  const [filteredRecordFromExcelSheet, setFilteredRecordFromExcelSheet] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAndUpdateData = async () => {
    try {
      setLoading(true);
      const uniqueData = await loadAllMedicine();

      // Update state
      setRecordFromExcelSheet(uniqueData);
      setFilteredRecordFromExcelSheet(uniqueData);
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAndUpdateData();
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    debouncedFilter(query);
  };
      
  // Debounced function to filter records from Excel sheet
  const debouncedFilter = useMemo(
    () =>
      debounce((query) => {
        const filtered = recordFromExcelSheet?.filter((item) =>
          Object.values(item).some((value) =>
            value?.toString().toLowerCase().includes(query.toLowerCase())
          )
        );
        setFilteredRecordFromExcelSheet(filtered);
      }, 300), // Adjust the debounce delay as necessary
    [recordFromExcelSheet]
  );

  // Delete item from selectedItems
  const handleDeleteItem = (_id) => {
    setFilteredRecordFromExcelSheet(filteredRecordFromExcelSheet?.filter(item => item._id !== _id));
    deleteExtraMedicineForSupply(_id);
  };

  if (loading) return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );

  return (
    <>
      <div className="createProduct mt-2">
        <Helmet>
          <meta name="description" content="Generate Invoice" />
          <title>Generate Invoice | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-12 inline-extra-style">
              <h5>Supply Medicine List</h5>
              <div className="allProducts__productStatusFilter">
                <div className={`allProducts__productStatusContent allProducts__flexContent mr-4`}>
                  <Button
                    variant="contained"
                    className={`employerIndex__createPostBtn employerIndex__createProduct`}
                    onClick={() => history.push('/supply/add-extra-medicine')}>Add Extra Medicine</Button>
                </div>
                <div className={`allProducts__productStatusContent allProducts__flexContent ml-5`}>
                  <Button
                    variant="contained"
                    className={`employerIndex__createPostBtn employerIndex__createProduct`}
                    onClick={() => history.push('/supply/import-extra-medicine')}>Import Extra Medicine From Invoice</Button>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-4">
              <input
                type="text"
                placeholder="Search Medicine..."
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ marginBottom: "10px", padding: "5px", width: "100%" }}
              />
            </div>
            <div className="generic-tab mt-2">
              <div className="row mb-3 row--col--md--12">
                <div className="col-md-12 mb-2 searchOrAdd">
                  <div className="list-table-container">
                    <div className="list-table-header">
                      <div>Particulars</div>
                      <div>Scheme</div>
                      <div>Pack Size</div>
                      <div>Company</div>
                      <div>HSN</div>
                      <div>Batch</div>
                      <div>Expiry</div>
                      <div>MRP</div>
                      <div>Wholesaler</div>
                      <div>Action</div>
                    </div>
                    <List
                      height={500} // Height of the table container
                      itemCount={filteredRecordFromExcelSheet?.length} // Total rows
                      itemSize={50} // Row height
                      width="100%" // Full width
                    >
                      {({ index, style }) => (
                        <div style={style} className="list-table-row">
                          <div>{filteredRecordFromExcelSheet[index]?.ProductName || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.ProductScheme || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.PackagingSize || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.Company || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.HSNCode || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.BatchNo || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.ExpiryDate || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.MRP || "N/A"}</div>
                          <div>{filteredRecordFromExcelSheet[index]?.Wholesaler || "N/A"}</div>
                          <div className="deleteCursor"><DeleteIcon onClick={() => handleDeleteItem(filteredRecordFromExcelSheet[index]?._id)} /></div>
                        </div>
                      )}
                    </List>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </div>
    </>
  )
}

export default SupplyMedicine
